import styled, { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { themeGet } from '@styled-system/theme-get';
import { Rating } from '@mui/material';

import Text from '../../../../shared/Text';
import { useReportsRatingsList } from '../data';
import { RatingsReport } from './RatingsReports.jsx';
import Button from '../../../../shared/Button';

export const RatingsList = ({ campaignId, onClose }) => {
  const theme = useTheme();
  const { t } = useTranslation('reports');
  const { data } = useReportsRatingsList({
    campaignId,
  });

  return (
    <Wrapper>
      <Header>
        <Text variant="h5">{t('rating.modalTitle')}</Text>
        <RatingsReport />
        <Button onClick={() => onClose()} mode="text" variant="black">
          <i className="fa-solid fa-x"></i>
        </Button>
      </Header>
      <TableWrapper>
        <Text variant="button">Date</Text>
        <Text variant="button">Name</Text>
        <Text variant="button">Answer</Text>
        <Text variant="button">Comment</Text>
        {data.data.map(row => (
          <>
            <Text display="inline-block" color="black.100" variant="small1">
              {row.date}
            </Text>
            <Text variant="small1">{row.user}</Text>
            <Rating
              value={row.feedback}
              edit={false}
              icon={
                <i
                  className="fa fa-star"
                  style={{ color: theme.colors.primary['100'] }}
                ></i>
              }
              emptyIcon={
                <i
                  className="fa fa-star"
                  style={{ color: theme.colors.black['20'] }}
                ></i>
              }
              readOnly
            />
            <Text as="p" variant="small1">
              {row.feedbackMessage}
            </Text>
          </>
        ))}
      </TableWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 24px;
  width: 909px;
  max-height: 800px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const TableWrapper = styled.div`
  padding: 24px;
  border-radius: 8px;
  border: 1px solid ${themeGet('colors.black.10')};
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  row-gap: 12px;
  align-items: center;
`;
